export default __webpack_public_path__ + "static/media/timeline.9d38281d.png";